import { z } from "zod";

export const schema = z
	.object({
		id_empresa: z.number().int("Campo id_empresa é obrigatorio"),
		nome: z.string().min(1, "Campo nome da empresa é obrigatório"),
		fantasia: z.string().nullable(),
		ativo: z.boolean(),
		rua: z.string().nullable(),
		numero: z.union([z.string(), z.null()]),
		// numero: z
		// 	.union([z.string(), z.null()]) // Permite string ou null
		// 	.refine((value) => value !== null && value.trim().length > 0, {
		// 		message: "Campo número é obrigatório, se não houver número, digite s/n",
		// 	}),
		complemento: z.string().nullable(),
		bairro: z.string().nullable(),
		cep: z.union([z.string(), z.null()]).refine(
			(cep) => {
				if (!cep) return false; // Trata null e string vazia como inválidos
				const trimmedCep = cep.trim();
				return /^\d{5}-\d{3}$/.test(trimmedCep);
			},
			{
				message: "CEP inválido.",
			}
		),
		id_cidade: z.coerce
			.number({ invalid_type_error: "Selecione uma cidade" }) // Converte o valor para número
			.int("O campo id_cidade deve ser um número inteiro.") // Valida que é inteiro
			.refine((val) => val > 0, {
				// Garante que seja maior que 0
				message: "Selecione uma cidade válida",
			}),
		telefone_1: z.string().nullable(),
		telefone_2: z.string().nullable(),
		obs: z.string().nullable(),
		email: z.lazy(() => z.string().email("Digite um e-mail válido").nullable().or(z.literal(""))),
		uf: z.string().nullable(),
		url_logo: z.string().nullable(),
		url_background: z.string().nullable(),
		
		// Configuração Catálogo
		id_configuracao_catalogo: z.number().int().optional().nullable(),
		theme: z.string().nullable(),
		entrega_transportadora: z.boolean(),
		entrega_local: z.boolean(),
		complementos: z.boolean(),
		validar_estoque: z.boolean(),
		titulo_seo: z.string().max(100, "O título SEO deve ter no máximo 100 caracteres").nullable().or(z.literal("")),
		descricao_seo: z.string().max(300, "A descrição SEO deve ter no máximo 300 caracteres").nullable().or(z.literal("")),
	})
	.refine((data) => !(data.rua && data.rua.trim().length > 0) || (data.numero && data.numero.trim().length > 0), {
		message: "Campo número é obrigatório se a rua estiver preenchida",
		path: ["numero"],
	})
	.refine((data) => !(data.numero && data.numero.trim().length > 0) || (data.rua && data.rua.trim().length > 0), {
		message: "Campo rua é obrigatório se o número estiver preenchido",
		path: ["rua"],
	});
export const schemaDefaultValues = {
	id_empresa: 0,
	nome: "",
	fantasia: "",
	telefone_1: "",
	telefone_2: "",
	cep: "",
	uf: "",
	ativo: true,
	data: new Date(),
	id_cidade: 0,
	rua: "",
	bairro: "",
	numero: "",
	complemento: "",
	url_logo: "",
	url_background: "",
	id_configuracao_catalogo: 0,
	theme: "RED",
	entrega_transportadora: true,
	entrega_local: false,
	complementos: false,
	validar_estoque: true,
	titulo_seo: "",
	descricao_seo: "",
};

// schema dicas
//#region verificando validade de um select usando numeros inteiros
// id_cidade: z.coerce
// 			.number({ invalid_type_error: "Selecione uma cidade" })
// 			.int("O campo id_cidade deve ser um número inteiro.")
// 			.refine((val) => val > 0, {
// 				message: "Selecione uma cidade válida",
// 			}), //z.number().int("Selecione a cidade antes de continuar"),
//-----------------------------------------------------------------------------------------------
// z.coerce.number({ invalid_type_error: "Selecione uma cidade" })
//     O que faz: Tenta converter o valor para um número.
//     Erro se falhar: Mostra a mensagem "Selecione uma cidade" se o valor não puder ser convertido em número (por exemplo, se for uma string ou estiver vazio).
// .int("O campo id_cidade deve ser um número inteiro.")
//     O que faz: Valida que o valor é um número inteiro.
//     Erro se falhar: Mostra a mensagem "O campo id_cidade deve ser um número inteiro." se o número tiver casas decimais (como 1.5).
// .refine((val) => val > 0, { message: "Selecione uma cidade válida" })
//     O que faz: Garante que o número seja maior que 0.
//     Erro se falhar: Mostra a mensagem "Selecione uma cidade válida" se o número for 0 ou negativo.
//#endregion

//#region fazendo um Uppercase nos campos pós validação
// .transform((fields) => {
// 	return {
// 		...fields,
// 		nome: fields.nome.toUpperCase(),
// 		fantasia: fields.fantasia ? fields.fantasia.toUpperCase() : null,
// 		rua: fields.rua ? fields.rua.toUpperCase() : null,
// 		bairro: fields.bairro ? fields.bairro.toUpperCase() : null,
// 		obs: fields.obs ? fields.obs.toUpperCase() : null,
// 		email: fields.email ? fields.email.toUpperCase() : null,
// 	};
// })
//#endregion

// .refine(
// 	(fields) => {
// 		// Verifica se o campo de rua não está vazio e não é nulo
// 		if (fields.rua && fields.rua !== null && fields.rua.trim() !== "") {
// 			// Verifica se a rua contém uma vírgula
// 			return fields.rua.includes(",");
// 		}
// 		// Retorna verdadeiro se o campo de rua estiver vazio ou nulo
// 		return true;
// 	},
// 	{
// 		path: ["rua"],
// 		message: "O endereço deve conter uma vírgula para separar o endereço do número.",
// 	}
// );
// codigo: z
// 	.number({
// 		errorMap: () => {
// 			return { message: "Informe um número válido" };
// 		},
// 	})
// 	.positive("Por favor, informe um número maior que 0"),
// .refine(
// 	(fields) => {
// 		// Verifica se o campo de rua não está vazio e não é nulo
// 		if (fields.rua && fields.rua !== null && fields.rua.trim() !== "") {
// 			// Verifica se a rua contém uma vírgula
// 			return fields.rua.includes(",");
// 		}
// 		// Retorna verdadeiro se o campo de rua estiver vazio ou nulo
// 		return true;
// 	},
// 	{
// 		path: ["rua"],
// 		message: "O endereço deve conter uma vírgula para separar o endereço do número.",
// 	}
// );

// Permite string ou null
// .refine((value) => value !== null && value.trim().length > 0, {
// 	message: "Campo número é obrigatório, se não houver número, digite s/n",
// }),
